var exports = {
  "kL": "container__zfDDsz",
  "w4": "resizing__wC5yBD",
  "vK": "banner__WME-my",
  "pz": "sidebar__IicaTV",
  "Em": "mainColumn__hIwnbD",
  "vA": "secondaryColumn__MJNch7",
  "Lz": "slimLineTopTabs__iMZ-bI",
  "ph": "monoView__-ctB-3",
  "qg": "sidebarCondensed__QSQ3Z2",
  "eo": "panelView__NiUf0k",
  "mv": "columnLeft__sldFCC",
  "PU": "secondaryColumnVisible__NGMLEl",
  "Lj": "resourcePanelOpen__VPTG8E",
  "gW": "secondaryColumnFullWidth__t4i2xi",
  "Jj": "columnRight__ATwLnN",
  "ix": "splitView__4e6gEt",
  "I9": "mainColumnRight__TdAeXO",
  "JM": "verticalSecondaryColumn__GOJS3K",
  "BP": "secondaryColumnHidden__aVzUW8",
};

module.exports = exports;
